(function () {
    "use strict";

    angular.module("virtualFairs")
        .controller("VirtualFairMicrositesFormController", VirtualFairMicrositesFormController);
    
    VirtualFairMicrositesFormController.$inject = ["VirtualFairService", "virtualFairs", "id", "toastr", "$state"];
    
    function VirtualFairMicrositesFormController(VirtualFairService, virtualFairs, id, toastr, $state) {
        
        var vm = this;

        vm.getTitle = getTitle;
        vm.mountMicrosite = mountMicrosite;
        vm.goToList = goToList;
        vm.loadMicrosite = loadMicrosite;
        vm.saveMicrosite = saveMicrosite;
        vm.clearVirtualFairs = clearVirtualFairs;
        vm.addSession = addSession;
        vm.removeSession = removeSession;
        vm.title = "Create Microsite"
        vm.flag = true;
        vm.errors = false;

        // New
        vm.virtualFairs = virtualFairs;
        vm.id = id;

        vm.microsite = {
            virtual_fair_id : null,
            name: null,
            key: null,
            city: null,
            country: null,
            sessions: [{ date: null, start_time: null, end_time: null }],
        }

        vm.logicOptions = [
            {id: 0, name: 'No'},
            {id: 1, name: 'Yes'}
        ];

        vm.dateOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: false,
            locale: {
              format: "DD/MM/YYYY",
              cancelLabel: "Close"
            },
        };

        vm.dateTimeOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: true,
            locale: {
              format: "DD/MM/YYYY HH:MM",
              cancelLabel: "Close"
            },
        };

        async function getTitle () {
            if(vm.id) {
                vm.title = "Edit Microsite"
            }
            return await vm.title;
        }

        async function mountMicrosite() {
            vm.microsite = {
                virtual_fair_id : "",
                name: "",
                key: "",
                city: "",
                country: "",
                date: "",
                start_time: "",
                end_time: "",
                sessions: []
            }
            vm.addSession();
        }

        async function saveMicrosite () {
            vm.flag = false;
            vm.errors = false;
            let fields = {};
            fields.id = vm.id;
            fields.virtual_fair_id = vm.microsite.virtual_fair_id;
            fields.name = vm.microsite.name;
            fields.key = vm.microsite.key;
            fields.city = vm.microsite.city;
            fields.country = vm.microsite.country;
            fields.sessions = vm.microsite.sessions;
            $.each(fields.sessions, function(key, value) {
                value.date = moment(value.date).format('YYYY-MM-DD');
                value.start_time = moment(value.start_time).format('YYYY-MM-DD HH:mm:ss');
                value.end_time = moment(value.end_time).format('YYYY-MM-DD HH:mm:ss');
            });
            fields.sessions = JSON.stringify(fields.sessions);
            VirtualFairService.storeSchoolVisit(fields).then(function(response) {
                vm.flag = true;
                if(vm.id) {
                    toastr.success('Microsite successfully updated!');
                    vm.goToList();
                } else {
                    toastr.success('Microsite successfully created!');
                    vm.goToList();
                }
            }).catch(function(err){
                vm.errors = err.data;
            })
        }

        async function goToList () {
            return await $state.go('root.virtualfair.reports.microsites');
        }

        async function loadMicrosite () {
            if(vm.id) {
                VirtualFairService.getSchoolVisit(vm.id).then(function(response) {
                    vm.flag = true;
                    vm.microsite = {
                        id: response.data.id,
                        virtual_fair_id: response.data.virtual_fair_id,
                        name: response.data.name,
                        key: response.data.key,
                        city: response.data.city,
                        country: response.data.country,
                        sessions: []
                    };

                    if(response.data.sessions.length == 0) {
                        vm.microsite.sessions.push({id: null, date: response.data.date, start_time: response.data.start_time, end_time: response.data.end_time});
                    } else {
                        angular.forEach(response.data.sessions, function(value, key) {
                            vm.addSession({id: value.id, date: value.date, start_time: value.start_time, end_time: value.end_time});
                        });
                    }
                })
            }
        }

        async function addSession (session = false) {
            if (session) {
                return vm.microsite.sessions.push({ id: session.id, date: session.date, start_time: session.start_time, end_time: session.end_time });
            }
            return vm.microsite.sessions.push({id: null, date: null, start_time: null, end_time: null });
        }

        async function removeSession (session) {
            if(typeof vm.microsite.sessions === 'object' && vm.microsite.sessions.length > 1) {
                vm.microsite.sessions.splice(vm.microsite.sessions.indexOf(session), 1);
            }
            return await vm.microsite.sessions;
        }

        async function clearVirtualFairs () {
            vm.virtualFairs.filter(item => {
                if(item.is_high_school == "0") {
                    vm.virtualFairs.splice(vm.virtualFairs.indexOf(item), 1);
                }
            })
        }

        async function activate() { 
            await vm.clearVirtualFairs();
            await vm.getTitle();
            await vm.loadMicrosite();
            await vm.mountMicrosite();
        }

        activate();
    }
})();
